import { AbstractControl, FormControl, FormGroup, ValidationErrors } from "@angular/forms";
import { Validators } from "@angular/forms";
import { buildPasswordPatternValidator, getPasswordPattern } from "../../_helpers/user.helper";
import { PasswordPattern } from "../../_interfaces/password-pattern";
import { User } from "../../_interfaces/user";

export class ResetPassword {
    private pattern: PasswordPattern;

    private form = new FormGroup({
        currentPassword: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
        newPassword: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
        confirmPassword: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
    }, { validators: this.passwordMatchValidator });

    constructor(pattern: PasswordPattern, currentRequired?: boolean) {
        this.pattern = pattern;
        this.setPasswordValidators(pattern, currentRequired);
    }

    private noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (value && /\s/.test(value)) {
            return { whitespace: true };
        }
        return null;
    }

    private setPasswordValidators(pattern: PasswordPattern, currentRequired = true): void {
        this.form.get('newPassword')?.setValidators([Validators.required, this.noWhitespaceValidator, ...buildPasswordPatternValidator(pattern)]);
        const currentPassword = this.form.get('currentPassword');
        currentRequired ? currentPassword?.setValidators([Validators.required, this.noWhitespaceValidator]) : currentPassword?.setValidators([]);
    }

    private passwordMatchValidator(form: AbstractControl): ValidationErrors | null {
        const newPassword = form.get('newPassword');
        const confirmPassword = form.get('confirmPassword');
    
        if (newPassword && confirmPassword && newPassword.value !== confirmPassword.value) {
            confirmPassword.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true };
        }
        
        // Clear passwordMismatch error if passwords match
        if (confirmPassword?.hasError('passwordMismatch')) {
            const errors = confirmPassword.errors;
            delete errors?.['passwordMismatch'];
            confirmPassword.setErrors(Object.keys(errors || {}).length > 0 ? errors : null);
        }
        
        return null;
    }

    getPattern(): PasswordPattern {
        return this.pattern;
    }

    getForm(): FormGroup {
        return this.form;
    }

    static fromUser(user: User): ResetPassword {
        const pattern = getPasswordPattern(user);
        return new ResetPassword(pattern);
    }
}